module.exports = __webpack_public_path__ + "static/media/heart-disabled.2a94f7f5.svg";